import React, { FC } from "react";
import cn from "classnames";
import { Category } from "src/components/BlogCard/Category";
import { ReadingTime } from "src/components/BlogCard/ReadingTime";
import { Date } from "src/components/BlogCard/Date";
import { Link } from "src/components/Link";

const DEFAULT_CLASSNAME = "flex-1 flex justify-center";

interface Props {
  category: string;
  read_time: string;
  pathBlogWithCategory: string;
  date: string;
}

export const AboutLabel: FC<Props> = ({
  category,
  pathBlogWithCategory,
  read_time,
  date,
}) => {
  return (
    <div className="flex justify-between">
      <Link className={DEFAULT_CLASSNAME} href={pathBlogWithCategory}>
        <Category className="flex-col md:flex-row" category={category} />
      </Link>
      <ReadingTime
        className={cn(DEFAULT_CLASSNAME, "flex-col md:flex-row md:border-x")}
        read_time={read_time}
      />
      <Date
        className={cn(DEFAULT_CLASSNAME, "flex-col md:flex-row")}
        date={date}
      />
    </div>
  );
};
